import { MarkdownField } from '@scale/shared/types/params/textcollection';
import { MarkdownFieldAnnotation } from '@scale/shared/types/response/textcollection';
import FieldHeader from 'react-scale/components/scalers/tasks/textcollection/SimpleTextCollection/FieldHeader';
import MarkdownEditorContext from '../../ThreadedInteraction/components/editor/MarkdownEditorContext';
import {
  Editor,
  EditorContainer,
  MarkdownFloatingMenu,
} from '../../ThreadedInteraction/components/editor';
import MarkdownToolbar from '../../ThreadedInteraction/components/editor/toolbar/MarkdownToolbar';
import { useMarkdownSyntaxOptions } from '../../ThreadedInteraction/hooks/useMarkdownSyntaxOptions';

type MarkdownFieldSectionProps = {
  field: MarkdownField;
  annotation: MarkdownFieldAnnotation;
  setAnnotation: (annotation: MarkdownFieldAnnotation) => void;
  disabled?: boolean;
  assignmentId?: string;
  enableRTLText?: boolean;
};

const MarkdownFieldSection = ({
  field,
  annotation,
  setAnnotation,
  enableRTLText,
}: MarkdownFieldSectionProps) => {
  const markdownSyntaxConfig = useMarkdownSyntaxOptions();

  const handleEditorUpdate = (value: string) => {
    setAnnotation({
      ...annotation,
      response: [value],
    });
  };

  const editorComponent = (
    <>
      <MarkdownEditorContext
        defaultTokens={markdownSyntaxConfig}
        initialContent={annotation.response[0] ?? field.default_text ?? ''}
      >
        <EditorContainer>
          <MarkdownToolbar />
          <MarkdownFloatingMenu />
          <Editor
            placeholder={field.hint}
            onContentChange={handleEditorUpdate}
            enableRTL={enableRTLText}
          />
        </EditorContainer>
      </MarkdownEditorContext>
    </>
  );

  return (
    <div className="flex flex-col gap-2">
      <FieldHeader title={field.title} description={field.description} hint={field.hint} />
      {editorComponent}
    </div>
  );
};

export default MarkdownFieldSection;
